import http from '../utils/http';
import i18n from '@/main';

const baseRoute = '/laudo/empresa';

export default {
    buscarTiposLaudo() {
        return http.get({
            url: baseRoute + `/tipos-laudo`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTiposDeLaudo')
        });
    },

    buscarTotalLaudosVinculados() {
        return http.get({
            url: baseRoute + '/vinculados/total',
            lockScreen: false
        });
    },

    buscarLaudosPorEmpresa(idEmpresa) {
        return http.get({
            url: baseRoute + `/tipos-laudo/${idEmpresa}`,
            lockScreen: false
        });
    },

    buscarQtdLaudosPorEmpresa(filtro, { pagina, tamanho }) {
        return http.post({
            url: baseRoute + `/empresas?page=${pagina - 1}&size=${tamanho}&sort=`,
            data: filtro,
            lockScreen: false
        });
    },

    vincularLaudosEmpresa(idEmpresa, idsLaudos) {
        return http.post({
            url: baseRoute + `/vincular/${idEmpresa}?idsLaudos=${idsLaudos}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.vinculandoLaudosAsEmpresas')
        });
    },

    vincularLaudosEmpresas(idsEmpresas, idsLaudos) {
        return http.post({
            url: baseRoute + `/vincular/lote?idsEmpresas=${idsEmpresas}&idsLaudos=${idsLaudos}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.vinculandoLaudosAsEmpresas')
        });
    },

    removerLaudosEmpresas(idsEmpresas, idsLaudos) {
        return http.delete({
            url: baseRoute + `/desvincular?idsEmpresas=${idsEmpresas}&idsLaudos=${idsLaudos}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.desvinculandoLaudosDeEmpresas')
        });
    }
};
